/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, useEffect } from "react";
import { fieldMessageWrapperCss, relativeFieldWrapperCss } from "./styles";

type Props = {
  visible: boolean;
  message: string;
  onTimerElapsed: (val: boolean) => void;
  children: React.ReactNode;
};

const AutoCloseTooltip: FC<Props> = ({
  message,
  visible,
  onTimerElapsed,
  children,
}) => {
  const DEBOUNCE_TIMER = 5 * 1000;

  useEffect(() => {
    const msgTimer = setTimeout(() => onTimerElapsed(false), DEBOUNCE_TIMER);
    return () => {
      clearTimeout(msgTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <div css={relativeFieldWrapperCss}>
      {children}
      {visible && <div css={fieldMessageWrapperCss}>{message}</div>}
    </div>
  );
};

export default AutoCloseTooltip;
export type AutoCloseTooltipProps = Props;
